export const PaginationHelperMixin = {
    methods: {
        recordPageToStorage : (pageNumber, pageKey) => {
            localStorage.setItem(pageKey, pageNumber)
        },
        getCurrentPageNumber: (pageKey)=> {
            return localStorage.getItem(pageKey) ? localStorage.getItem(pageKey) : 1;
        }
    },
}